module.exports = __webpack_public_path__ + "img/bx-qapaper.55a251a6.svg";